import React, { useState, useEffect, useRef } from 'react';
import { Layout } from 'antd';
import styles from './TopBar.module.css';
import UserDropdown from '../UserDropdown/UserDropdown';
import CHLogo from "../../../assets/img/Carehires_main_logo.png";
import CHText from "../../../assets/img/CH_Horizontal_Logo.png";
import { BreadCrumbs } from '../../Breadcrumbs/Breadcrumbs';
import { enableChristmasTheme, enableEasterTheme } from '../../../utils/chSeasonTheme';
import useUserflow from '../../../hooks/useUserflow';
import CareHiresLogo from '../../../assets/img/CH_New_Logo.png';

const { Header } = Layout;

interface TopBarProps {
  breadcrumbsItems: string[];
}

const TopBar: React.FC<TopBarProps> = ({ breadcrumbsItems }) => {
  const [isComponentVisible, setIsComponentVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useUserflow(import.meta.env.VITE_ENV as string);

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      setIsComponentVisible(false);
    }
  };

  const handleEscapeKey = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscapeKey);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, []);

  return (
    <Header
      className={`${styles['header-container']} ${enableChristmasTheme()
          ? `${styles['banner']} ${styles['christmas-theme']}`
          : enableEasterTheme()
            ? `${styles['banner']} ${styles['easter-theme']}`
            : ''
        }`}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img style={{ width: 50, height: 50, marginLeft: '0.5rem', marginBottom: 10 }} src={CHLogo} alt="logo" />
        <div style={{ position: "relative", marginTop: '-33px' }}>
          <div className={styles.topbarLogo}>
          {/* <div className={styles.poweredByContainer}> 
            <img
              className="login-title"
              src={CareHiresLogo}
              alt="CareHires Logo"
            />
          </div> */}
          {/* <div className={styles.profileText}>Profile</div> */}
          </div>
          <div style={{ position: "absolute", top: '90%', marginLeft: '0.5rem' }}>
            <BreadCrumbs breadcrumbItems={breadcrumbsItems} />
          </div>
        </div>
      </div>
      <div className={styles.profileSection} ref={ref}>
        <UserDropdown />
      </div>
    </Header>
  );
};

export default TopBar;